var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smain"},[_vm._v(" sadasdasd ")])
}
var staticRenderFns = []

export { render, staticRenderFns }